import { runActions } from "../action";
import { IDecorator, INmis } from "../types";
import { Decorator } from "./decorator";
import filterTool from "../util/filterTool";

export class CustomModalDecorator extends Decorator implements IDecorator {
    public static NAME: string = "customModal";

    // 

    /**
     * 获取当前对象实例
     * @returns 
     */
    getInstance() {
        return new CustomModalDecorator();
    }

    // /**
    //  * 0. created
    //  * @param nmis 
    //  */
    // created(nmis: INmis) {
    //     this.nmis = nmis;
    //     if (filterTool.isNull(this.nmis!.currentData.show)) {
    //         this.nmis.$set(this.nmis!.currentData, 'show', false);
    //     }
    // }

    /**
     * 1. 开始初始化
     */
    beforeInit() {
        if (filterTool.isNull(this.nmis!.currentData.show)) {
            this.nmis!.$set(this.nmis!.currentData, 'show', false);
        }
        this.addProp("show", this.nmis!.currentData.show);

        this.addEvent("update:show", (val) => {
            this.nmis!.$set(this.nmis!.currentData, 'show', val);
            console.log("currentData", this.nmis!.currentData);            
        })
    }

    /**
     * 显隐控制
     * @param type 
     */
    showHidden(type: 'show' | 'hidden' | "mutex") {
        if (type == 'mutex') {
            this.nmis!.$set(this.nmis!.currentData, 'show', filterTool.isNull(this.nmis!.currentData.show) ? true : !this.nmis!.currentData.show);
            return;
        }
        this.nmis!.$set(this.nmis!.currentData, 'show', type == 'show');
        this.nmis!.update();
    }

}